<template>
  <div>
    <div v-for="(f,i) in form" :key="i" class="question-item" v-bind:class="{ 'disabled-question':disabled[f.id] }">
      <div v-if="(currentPage==(i+1) || currentPage=='*') && f.text!='-' " class="mb-10">
        <div v-if="f.option_type=='photo'" class="list_images mt-5 mb-5">
            <div no-gutters v-if="data_api.type=='pick_a_pict'">
                <v-row no-gutters >
                    <v-col cols="6" :md="form.length<9?6:(form.length<16?4:3)" v-for="(a,i) in shuffleAnswer" :key="i">
                        <div v-if="answer" class="item_select pick_a_pict mx-0"  v-bind:class="{ 
                            active: answerPassed.includes(a.answers[0].id) || ( question[f.id]==a.answers[0].id && answer[f.id]),                                    
                            benar : selectAnswer[a.answers[0].id],
                            salah: !selectAnswer[a.answers[0].id]}">
                            <div class="item_select_image mb-3 pointer" @click="chooseAnswer(f, a.answers[0])">
                              <div class="img">
                                <img :src="a.answers[0].media" style="max-width: 100%;"/>
                              </div>
                              <div class="item_answer">
                                <div class="item_answer_image mt-1 ml-1 mr-1">
                                </div>
                                <div class="item_answer_text text-left align-center">
                                  {{a.answers[0].text}}
                                </div>
                              </div>
                            </div>
                        </div>	
                        <div v-else class="item_select">
                            <div class="item_select_image mb-3 pointer" @click="chooseAnswer(f, a.answers[0])">
                                <img :src="a.answers[0].media" style="max-width: 100%;"/>
                            </div>
                        </div>	
                    </v-col>
                </v-row>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "Answer",
  props:['form','currentPage','totalPage'],
  computed: mapState(['isLoading', 'isCombine', 'isValidAnswer', 'isValidProfiling', 'isValidCombine']),
  data() {
    return {
      selectAnswer: [],//selected answer with value true/false based on the real answer
      show: false,
      data_api: this.$store.state.data.get,
      shuffleAnswer: null,
      correctAnswer:[],//question that user answered correctly
      question:[],
      answerPassed:[],//correct answer from a question that user already answer (if the user answers wrong the data still get the correct answer for that question )
      valid: false,
      temp: {},
      disabled: {},
      isPrev: this.$store.state.data.get.display_options ? (JSON.parse(this.$store.state.data.get.display_options)?.display_button_previous == 'show' ? true : false) : false,
      answer: this.$store.state.data.post.answer,
    }
  },
  created(){
    if(this.data_api.type=='pick_a_pict'&& this.shuffleAnswer==null){
        var f =Object.assign([], this.form)
        this.shuffleAnswer=this.shuffle(f)
    }
    f.forEach(element => {
      this.question[element.answers[0].id_question]=element.answers[0].id 
    });
  },
  watch: {
    currentPage: {
      immediate: true,
      deep: true,
      handler() 
      {
        this.show = false
        var th = this

        setTimeout(function(){
          th.show = true
        },100);
      }
    }
  },

  methods:{
    shuffle(a) {
        var j, x, i;
        for (i = a.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = a[i];
            a[i] = a[j];
            a[j] = x;
        }
        return a;
    },
    chooseAnswer(field, answered)
    {
      
        if(this.data_api.type=='pick_a_pict'){
            var firstAnswer = this.answer[field.id] || []
            if(!this.answerPassed.includes(answered.id)){
              if(firstAnswer==null||firstAnswer.length==0){
                  this.$set(this.answer, field.id, answered.id);
                  this.$forceUpdate();
                  this.selectAnswer[answered.id]=false
                  this.answerPassed.push(this.question[field.id])
                  if(answered.id_question==field.id){
                      this.correctAnswer[field.id] = true
                      this.selectAnswer[answered.id]=true
                  }
                  var score = this.correctAnswer.filter(value => value === true).length
                  let obj = this.data_api.pick_a_pict_result.find(o => o.max_value >= score && o.min_value <= score);
                  if(obj===undefined){
                    var tempScore= score;
                    for (tempScore; tempScore > 0; tempScore--) {
                      obj = this.data_api.pick_a_pict_result.find(o => o.max_value >= tempScore && o.min_value <= tempScore);
                    }
                    if (tempScore==0){
                      tempScore = Math.min(...this.data_api.pick_a_pict_result.map(o => o.min_value));
                      obj = this.data_api.pick_a_pict_result.find(o => o.min_value == tempScore);
                    }
                  }
                  this.$store.state.PickAPictResult = obj
                  this.$store.state.PickAPictResult.score = score
              }
              this.toNextQuestion(field)
            }
        }else{
            this.$set(this.answer, field.id, answered.id);
            this.$forceUpdate();
        }
    },
    toNextQuestion(f)
    {
        //is using logic jump written answer?
        if( this.$store.state.data.get.using_jump_question=='yes' && f.answers )
        {
            if( f.other_label && this.answer[f.id] && isNaN(this.answer[f.id]) )
            {
              {   //result
                  this.$parent.$parent.$parent.submit()
              }
            }
        }
        this.$parent.next()
    },
  }
}
</script>